/*******************************************************
 * Copyright (C) 2010-Present Avant Assessment
 * All Rights Reserved
 *******************************************************/

import { Box } from "@material-ui/core"
import React from "react"
// @ts-ignore
import VideoRecorder from "react-video-recorder"
import {TLocalAnswer} from "../../types/types"
import Actions from "./VideoRenderActions";

interface ItemVideoRecorderProps {
    handleAnswerChange: (answer: TLocalAnswer | null) => void
}

export default function ItemVideoRecorder(props: ItemVideoRecorderProps) {
    const { handleAnswerChange } = props
    // todo: Determine what, if any, attribution is needed here

    // todo: handle error regarding lack of types for react-video-recorder (remove ts-ignore in imports for more info)

    // todo: inspect blob returned from VideoRecorder, determine if:
    // new Blob(newBlob, {type: "video/mp4"}) is needed (see OpusVoiceRecorder.tsx)

    return (
        <Box style={{ maxWidth: "100%" }}>
            <>
            <p className="speaking__prompt">Record your response below.</p>
            <Box style={{ margin: "30px", height: "400px"}}>

                {
                    <VideoRecorder
                    constraints={{
                        audio: false,
                        video: true
                    }}
                    timeLimit={240000} // 10000 = 10 secs
                    renderActions={Actions}
                    mimeType="video/webm;codecs=vp8,opus"
                    onStartRecording={() => {
                        console.log("recording started")
                    }}
                    onStopRecording={() => {
                        console.log("recording stopped")
                    }}
                    onRecordingComplete={(blob: Blob) => {
                        // When recording is complete, update the localAnswer state in the itemContainer
                        // component using the handleAnswerChange function.
                        console.log("recording complete")
                        handleAnswerChange(blob)
                    }}
                />}
            </Box>
            <p className="speaking__remember">Remember to...</p>
            <div className="writing__remember-point">
                <div className="writing__remember-point__icon">
                    <i className="material-icons writing__remember-point__icon__check">done</i>
                </div>
                {"\u00A0"} Use complete sentences
            </div>
            <div className="writing__remember-point">
                <div className="writing__remember-point__icon">
                    <i className="material-icons writing__remember-point__icon__check">done</i>
                </div>
                {"\u00A0"} Sign as much as you can, up to 4 minutes
            </div>
            <div className="writing__remember-point">
                <div className="writing__remember-point__icon">
                    <i className="material-icons writing__remember-point__icon__check">done</i>
                </div>
                {"\u00A0"} Watch your recording when you are done.
            </div>
        </>
        </Box>
    )
}